import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Stack Auth returns user data in URL hash or query params
        const params = new URLSearchParams(window.location.search);
        const hash = new URLSearchParams(window.location.hash.substring(1));
        
        // Try to get access token from hash or params
        const accessToken = hash.get('access_token') || params.get('access_token');
        const userEmail = hash.get('email') || params.get('email');
        const userName = hash.get('name') || params.get('name');
        
        if (!accessToken && !userEmail) {
          setError('No authentication data received');
          setTimeout(() => navigate('/'), 3000);
          return;
        }

        // If we have user data directly, use it
        let userData = {
          email: userEmail,
          name: userName
        };
        
        // If we only have access token, fetch user data
        if (accessToken && !userEmail) {
          const STACK_PROJECT_ID = process.env.REACT_APP_STACK_PROJECT_ID || '58dd3f39-e3f1-4510-b6c0-abe0be764ed5';
          
          const response = await fetch(`https://api.stack-auth.com/api/v1/users/me`, {
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'x-stack-project-id': STACK_PROJECT_ID
            }
          });

          if (response.ok) {
            userData = await response.json();
          }
        }
        
        const data = userData;
        
        // Create user object from Stack Auth response
        const user = {
          id: data.user_id || 'google_' + Date.now(),
          email: data.email,
          displayName: data.name || data.email,
          firstName: data.given_name || '',
          lastName: data.family_name || '',
          sport: '', // Will be set later
          role: data.email === 'rao.vinu@gmail.com' ? 'admin' : 'user',
          provider: 'google',
          createdAt: new Date().toISOString()
        };

        // Store user in auth
        localStorage.setItem('auth_user', JSON.stringify(user));
        
        // Store in users database
        const users = JSON.parse(localStorage.getItem('users_db') || '{}');
        users[user.email] = user;
        localStorage.setItem('users_db', JSON.stringify(users));

        // Redirect based on role
        if (user.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/user-dashboard');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/'), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
        <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-6 max-w-md">
          <p className="text-red-400 text-center">{error}</p>
          <p className="text-slate-400 text-sm text-center mt-2">Redirecting to home...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
      <div className="text-center">
        <Activity className="w-16 h-16 text-blue-400 mx-auto mb-4 animate-pulse" />
        <h2 className="text-2xl font-bold text-white mb-2">Signing you in...</h2>
        <p className="text-slate-400">Please wait while we complete authentication</p>
      </div>
    </div>
  );
};

export default AuthCallback;
